import React from 'react'
import { Navigate } from 'react-router'
import { AppRoutes } from '@core/AppRoutes'
import { useNewSportsOfferingFeature } from './hooks/useNewSportsOfferingFeature'
import { useToggleKambiBetSlipVisibility } from './hooks/useToggleKambiBetSlipVisibility'

const SportsOfferingLazyRoute = React.lazy(() => import('./Components/MainSportsOffering'))

export const SportOfferingRoot: React.FC = () => {
  const isKambiSportsOfferingEnabled = useNewSportsOfferingFeature()
  useToggleKambiBetSlipVisibility(isKambiSportsOfferingEnabled)

  if (!isKambiSportsOfferingEnabled) {
    return <Navigate to={AppRoutes.SportsRoot + '/home'} replace />
  }

  return (
    <React.Suspense fallback={null}>
      <SportsOfferingLazyRoute />
    </React.Suspense>
  )
}
